import { Loader2 } from "lucide-react";

export const FullPageSpinner = ({ label = "Loading" }) => (
  <div
    className="flex h-full items-center justify-center"
    role="status"
    aria-label={label}
  >
    <Loader2 className="size-8 animate-spin text-muted-foreground" />
  </div>
);
